interface LogoProps {
  size?: number
  className?: string
  alt?: string
  src?: string
}

export function Logo({
  size = 30,
  alt = 'Pros & Cons List',
  src = '/logos/logo.svg',
  className = '',
}: LogoProps) {
  return (
    <img
      src={src}
      width={size}
      height={size}
      alt={alt}
      className={`block dark:drop-shadow-glow shrink-0 ${className}`}
    />
  )
}
